import { useState } from "react";
import Banner from "../components/Banner";
import RegisterCallout from "../components/RegisterCallout";
import VideoModal from "../components/VideoModal";

export default function PageVenue() {
  const [isOpen, setIsOpen] = useState(false);
  const [videoId, setVideoId] = useState(null);

  const openOverlay = (id) => {
    setVideoId(id);
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeOverlay = () => {
    setIsOpen(false);
    setVideoId(null);
    document.body.style.overflow = "auto";
  };
  return (
    <>
      <Banner className="bg-venue-sandiego">
        <div className="col-12 mb-3">
          <div className="display-1 color-white">
            Estancia La Jolla Hotel & Spa
          </div>
        </div>
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-5">
            FinComp attendees can take advantage of an exclusive discounted rate
            of $329 per night (plus taxes and fees). The deadline to access this
            discounted hotel rate is Thursday, August 7, 2025.
          </p>
        </div>
        <div className="col-12">
          <a
            href="https://www.estancialajolla.com/"
            target="_blank"
            rel="noreferrer"
            className="btn-purple-with-icon me-4"
          >
            Hotel Website
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </a>
          <a
            href="https://be.synxis.com/?adult=1&arrive=2025-09-07&chain=11910&child=0&currency=USD&depart=2025-09-10&group=7901519&hotel=12323&level=hotel&locale=en-US&productcurrency=USD&rooms=1"
            target="_blank"
            rel="noreferrer"
            className="btn-purple-with-icon ms-4"
          >
            Book Your Stay
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </a>
        </div>
      </Banner>

      <section>
        <div className="container">
          <div className="row justify-content-center pt-5">
            <div className="col-10 px-0">
              <h1 className="small color-purple mb-4">
                Set amidst the picturesque landscape of La Jolla, Estancia La
                Jolla Hotel & Spa offers the perfect blend of elegance, comfort,
                and convenience for FinComp 2025.
              </h1>
              <p>
                Guests can take advantage of the hotel&apos;s prime location
                near the stunning Pacific coastline while enjoying easy access
                to San Diego&apos;s top attractions. Between sessions, attendees
                can unwind with on-site amenities, including exceptional dining
                options, a heated saltwater pool, and a world-class spa. Whether
                you&apos;re here to learn, network, or simply recharge, Estancia
                La Jolla ensures an unforgettable experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6">
              <img
                className="img-fluid"
                src="./img/graphic-dining-amenities.webp"
                alt="Dining and Amenities"
              />
            </div>
            <div className="col-4 px-0 offset-1">
              <h3 className="color-purple">Dining and Amenities</h3>
              <p>
                The property boasts multiple dining venues, a full-service,
                award-winning spa, fitness center, and a heated saltwater pool,
                ensuring a comfortable and enjoyable stay for all guests.
              </p>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="col-6 order-md-2 offset-1">
              <img
                className="img-fluid"
                src="./img/graphic-scenic-outdoor-spaces.webp"
                alt="Scenic Outdoor Spaces"
              />
            </div>
            <div className="col-4 order-md-1 px-0 offset-1">
              <h3 className="color-purple">Scenic Outdoor Spaces</h3>
              <p>
                The hotel&apos;s lush gardens, charming courtyards, and open-air
                meeting areas provide a refreshing setting for networking,
                breakout sessions, and relaxation between conference events.
              </p>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="col-6">
              <img
                className="img-fluid"
                src="./img/graphic-convenient-location.webp"
                alt="Convenient Location"
              />
            </div>
            <div className="col-4 px-0 offset-1">
              <h3 className="color-purple">Convenient Location</h3>
              <p>
                Situated near the stunning La Jolla coastline and just a short
                drive from San Diego International Airport, the venue offers
                easy access for travelers while providing a peaceful retreat
                from the city.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row justify-content-center pb-5">
            <div className="col-10 px-0">
              <div
                className="video-card"
                role="button"
                onClick={() => openOverlay("vmMNntGQ2L4")}
              >
                <img
                  className="img-fluid"
                  src="./img/graphic-venue-videostill.webp"
                  alt="Venue Video"
                />
                <div className="icon">
                  <i className="fa fa-play"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <VideoModal isOpen={isOpen} videoId={videoId} onClose={closeOverlay} />

      <RegisterCallout className="bg-before-white" />
    </>
  );
}
